import script from "./DocumentListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentListItem.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentListItem.vue?vue&type=style&index=0&id=18e2c158&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18e2c158"]])

export default __exports__